export default __webpack_public_path__ + "static/media/logox.971bcc25.png";